var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"development-history-page"},[_c('time-axis',{attrs:{"course":_vm.course}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }